import { render, staticRenderFns } from "./Proxers.vue?vue&type=template&id=f00375d8&scoped=true&"
import script from "./Proxers.vue?vue&type=script&lang=js&"
export * from "./Proxers.vue?vue&type=script&lang=js&"
import style0 from "./Proxers.vue?vue&type=style&index=0&id=f00375d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00375d8",
  null
  
)

export default component.exports